import { createRouter, createMemoryHistory, createWebHistory, createWebHashHistory } from 'vue-router';
import { store } from 'src/store/index.js';
import routes from './routes';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes: routes,

    // Leave this as is and make changes in the quasar.config file instead!
    // quasar.config file -> build -> vueRouterMode
    // quasar.config file -> build -> publicPath
    mode: process.env.VUE_ROUTER_MODE,
    base: process.env.VUE_ROUTER_BASE,
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  Router.beforeEach((to, from, next) => {
    if (window.location.href.startsWith('http://') && store.getters['config/config'].ENFORCE_HTTPS) {
      window.location = window.location.href.replace('http://', 'https://');
    }
    if (!to.meta.requiresAuth && !store.getters['user/label']) {
      store.dispatch('user/setLabel');
    }

    next();
  });

  return Router;
}
